module.exports = __webpack_public_path__ + "img/homt__1f10x5——vi.0a99274b.png";